import styled from "styled-components";

export const BodyWrapper = styled.div`
  .user-header {
    display: flex;
    align-items: center;
    gap: 15px;
    border-bottom: 1px solid #0000001a;
    padding:  15px;
    justify-content: flex-end;
    .search-input {
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      width: 185px;
      height: 30px;
      padding: 5px 10px;
    }
    .clear-button {
      border: 1px solid #cdcfd0;
      border-radius: 30px;
      height: 30px;
      font-size: 13px;
      line-height: 150.5%;
      color: #1d1d1d;
      text-transform: capitalize;
      font-weight: 400;
    }
    .react-select__control {
      min-height: 30px;
      font-size: 14px;
      box-shadow: none;
      border: 1px solid #cdcfd0;
      margin-inline: 0;
    }
    .react-select__indicators {
      svg {
        width: 20px;
      }
    }
    .react-select__option {
      font-size: 14px;
      input[type="checkbox"] {
        accent-color: #bc9b6a;
      }
    }
    .react-select__option--is-focused {
      background-color: #f5f5d480;
    }
    .react-select__option--is-selected {
      background-color: #f4f4d4;
    }
    > div {
      > button {
        background: #ffffff;
        border: 1px solid #cdcfd0;
        border-radius: 6px;
        font-weight: 400;
        font-size: 13px;
        line-height: 150.5%;
        color: #000000;
        padding: 2px 10px;
      }
    }
  }
`;
export const Container = styled.div`
  padding: 22px 40px;
  background: #fafcff;
`;

export const UserHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #0000001a;
  padding: 36px 15px 13px;
  gap: 10px;
  flex-wrap: wrap;
  .MuiSelect-select {
    font-size: 13px;
    padding: 3.5px 14px;
  }
  .MuiOutlinedInput-notchedOutline {
    border-color: #cdcfd0;
  }
  .MuiSvgIcon-root {
    width: 20px;
    height: 26px;
  }
  .search {
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    height: 30px;
    padding: 0 10px;
  }
  .row-select-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    span {
      font-weight: 400;
      font-size: 13px;
      line-height: 16px;
    }
  }
  .role-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
  }
`;

export const Wrapper = styled.div`
  background: #ffffff;
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.05);
`;

export const UserTableMainWrapper = styled.div`
  padding: 10px 22px;
  > div {
    height: calc(100vh - 201px);
  }
  .k-grid,
  .k-grid-header {
    border: none;
  }
  .k-table {
    display: table;
    width: 950px;
    border-spacing: 0 5px;
  }
  .k-grid-pager {
    justify-content: flex-end;
  }
  .k-pager-numbers-wrap {
    > button:first-child,
    > button:last-child {
      display: none;
    }
  }
  .k-pager-sizes {
    position: relative;
  }
  .k-dropdownlist {
    position: relative;
    z-index: 1;
  }
  .k-button-flat-primary {
    color: #bc9b6a;
  }
  .k-pager-sizes::after {
    content: "Row per page";
    position: absolute;
    right: 0;
    background: #fff;
    padding: 0;
    left: 0;
    text-align: right;
  }
  /* .MuiDataGrid-columnHeader {
    width: auto;
    min-width: 60px;
    .MuiDataGrid-columnSeparator {
      display: none;
    }
    .MuiDataGrid-columnHeaderTitleContainer {
      justify-content: center;
    }
    :nth-child(1) {
      .MuiDataGrid-columnHeaderTitleContainer {
        justify-content: left;
      }
    }
  }
  .MuiDataGrid-columnHeaderTitle {
    white-space: break-spaces;
    font-size: 14px;
    line-height: 150.5%;
    text-align: center;
  }

  .MuiDataGrid-row {
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
    background: #f4f4d4;

    .MuiDataGrid-cell {
      border-bottom: none;
      justify-content: center;
      :nth-child(1) {
        justify-content: left;
      }
      :nth-child(even) {
        background: #fff6;
      }
    }
  } */
  .k-grid-header .k-header {
    background-color: #fff;
    border: none;
  }
  .k-table-tbody {
    background: #f4f4d4;
  }
  .k-grid td {
    text-align: center;
    background: #f4f4d4;
  }
  .k-grid td:first-child {
    border-left: 5px solid #947550;
  }
  .k-grid td:nth-child(even) {
    background-color: #ffffff66;
  }
  /* .k-grid td:nth-child(2n) {
    background-color: #ffffff66;
  } */
  .k-table-th:first-child,
  .k-table-td:first-child {
    text-align: left;
  }
  .k-grid tr.k-alt {
    background-color: inherit;
  }
  .k-cell-inner > .k-link {
    justify-content: center;
  }
  .k-table-row th:first-child .k-cell-inner .k-link {
    justify-content: flex-start;
  }
  .k-table-md .k-table-th,
  .k-table-md .k-table-td {
    padding: 10px 8px;
  }
`;
